export default {
	cartTabMenu: {
		label: "Carrello",
		emptyButton: "Svuotare",
		emptyButtonTooltip: "Rimuove tutti gli articoli dal carrello.",
	},
	cartTabMenuItem: {
		removeTooltip: "Rimuove l'articolo dal carrello.",
	},
	cartPosition: {
		showParts: "Mostra parti",
	},
	cartPositionItem: {
		materialLabel: "Materiale:",
		articleIdLabel: "Numero Blexon:",
		certificateLabel: "Certificato:",
		revalidateButton: "Blexonizzare",
		quantityUnit: "{quantity} pz.",
		quantityPlaceholder: "pz.",
		removeTooltip:
			"Rimuove l'articolo dal carrello. Non rimuove l'articolo dalle distinte base.",
		addToSavedCartTooltip: "Aggiungere la posizione alla distinta base attuale",
		loadError: "Impossibile caricare l'articolo.",
	},
	currentCart: {
		title: "Carrello",
		emptyButton: "Svuotare",
		emptyButtonTooltip: "Rimuove tutti gli articoli dal carrello.",
		createListButton: "Creare distinta base",
		createListButtonTooltip: "Creare una distinta base a partire dal carrello.",
		emptyCartText: "Il carrello è vuoto. Vada su {link} per aggiungere nuovi articoli al carrello.",
		emptyCartLinkText: "'Articoli'",
		newCartDialog: {
			title: "Nuova distinta base",
			text: "Il carrello verrà salvato come distinta base con il seguente nome:",
			nameLabel: "Nome della nuova distinta base",
			saveButtonTooltip: "Salva il carrello come distinta base.",
		},
		nameExistsError: "Esiste già una distinta base con questo nome.",
		messages: {
			cartSaved: "La distinta base è stata salvata.",
		},
	},
	savedCarts: {
		title: "Distinte base",
		noCartsText:
			"Non è ancora stata salvata nessuna distinta base. Aggiunga articoli al carrello per creare una nuova distinta base a partire dal carrello.",
		selectPlaceholder: "Selezionare una lista...",
		itemTooltipQuantity: "Quantità: {quantity}",
		deleteButton: "Eliminare",
		deleteButtonTooltip: "Eliminare la distinta base.",
		quantityLabel: "Quantità",
		quantityPlaceholder: "pz.",
		addButtonTooltip:
			"Aggiunge tutti gli articoli della distinta base al carrello. Per gli articoli già presenti, la quantità viene aumentata.",
		addButtonMultiple: "Aggiungere {amount} x al carrello",
		addButtonSingle: "Aggiungere al carrello",
		removeArticleTooltip: "Rimuovere dalla distinta base",
		addArticleTooltip: "Aggiungere al carrello",
		deleteDialog: {
			title: "Eliminare distinta base",
			text: "È sicuro di voler eliminare questa distinta base?",
			text2: "Gli articoli contenuti nella lista non verranno eliminati.",
			confirmButton: "Eliminare",
			confirmButtonTooltip: "Elimina definitivamente la distinta base.",
		},
		messages: {
			articlesAdded: "Gli articoli della distinta base sono stati aggiunti al carrello.",
			articleAdded:
				"{quantity} pz. aggiunti al carrello. {oldQuantity} + {quantity} = {newQuantity}",
			articleRemoved: "L'articolo è stato rimosso dalla distinta base.",
			cartDeleted: "La distinta base è stata eliminata.",
		},
	},
};
